import JSBI from 'jsbi'
// exports for external consumption
export type BigintIsh = JSBI | bigint | string

export enum ChainId {
  MAINNET = 1,
  ROPSTEN = 3,
  RINKEBY = 4,
  GÖRLI = 5,
  KOVAN = 42,

  OKEXCHAIN = 66,
  OKEXCHAIN_TESTNET = 65,

  BSC = 56,
  BSC_TESTNET = 97,

  MATIC = 137,
  MATIC_MUMBAI = 80001,

  DEV = 1337,
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT,
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP,
}

export const FACTORY_ADDRESS = '0x498225CdCA2256598D45904D515EBc9e7b4B7228'

export const INIT_CODE_HASH = '0x6c5de0c557eaa47927c0c766d79019a897028d77dec6f3ca8e4e3d8ac105bc92'

export const FACTORY_ADDRESSES: { [chainId in ChainId]?: string } = {
  [ChainId.OKEXCHAIN]: '0x2A24C4b12f62b14E35fdfFe9bAf9c2E16Ba11D08',
  [ChainId.OKEXCHAIN_TESTNET]: '0x1fE3ed44cA4a2add77BbCA7553e23CfA36Fa3e5a',
  [ChainId.MATIC]: '',
  [ChainId.MATIC_MUMBAI]: '0x0aE532B0d3066ff6d4f4EA55FE29D1b37cd8D0De',
  [ChainId.BSC]: '0x2A24C4b12f62b14E35fdfFe9bAf9c2E16Ba11D08',
  [ChainId.BSC_TESTNET]: '0x9f38cFC1B86698FE2a3c0b0FD1504c855596d2A9',
  [ChainId.GÖRLI]: '0xeb86db89953dF90C5cF6136B303d4d89398Fa07E',
  [ChainId.MAINNET]: '0x2A24C4b12f62b14E35fdfFe9bAf9c2E16Ba11D08',
}

export const INIT_CODE_HASHES: { [chainId in ChainId]?: string } = {
  [ChainId.OKEXCHAIN]: '0x98298017bcc1f221d4c741a0b2ba9dd37d645be3fd93ec79aaa4b2516289d470',
  [ChainId.OKEXCHAIN_TESTNET]: '0xe03d68db6b3b6c2e80ae8285de7c066ce3446aeb445391e429764dbdcc68ee13',
  [ChainId.MATIC]: '',
  [ChainId.MATIC_MUMBAI]: '0xade8b278d2f0f0da4d9d043fd0ac133a5c02eed5094e7ca3c6630caa64c9073e',
  [ChainId.BSC]: '0x98298017bcc1f221d4c741a0b2ba9dd37d645be3fd93ec79aaa4b2516289d470',
  [ChainId.BSC_TESTNET]: '0x5ebaa858afb401cfc6b62189261b88e455ac9d6cc692f2c54c554b82928c40c1',
  [ChainId.GÖRLI]: '0x4eb2a9a5e06a100e4d5b5e8d230ee3e75c09cda328f179296d2b372392167255',
  [ChainId.MAINNET]: '0x98298017bcc1f221d4c741a0b2ba9dd37d645be3fd93ec79aaa4b2516289d470',
}

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256',
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'),
}
